
// @ts-nocheck
import locale_de_46json_165a3efe from "#nuxt-i18n/165a3efe";
import locale_en_46json_0b63539c from "#nuxt-i18n/0b63539c";

export const localeCodes =  [
  "de",
  "en"
]

export const localeLoaders = {
  de: [
    {
      key: "locale_de_46json_165a3efe",
      load: () => Promise.resolve(locale_de_46json_165a3efe),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => Promise.resolve(locale_en_46json_0b63539c),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/ee4e6a16" /* webpackChunkName: "config_i18n_46config_46ts_ee4e6a16" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "./localeDetector.ts",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      name: "Deutsch",
      code: "de",
      iso: "de-DE",
      files: [
        {
          path: "/app/i18n/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      name: "English",
      code: "en",
      iso: "en-US",
      files: [
        {
          path: "/app/i18n/locales/en.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_lang",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    name: "Deutsch",
    code: "de",
    iso: "de-DE",
    files: [
      {
        path: "/app/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    name: "English",
    code: "en",
    iso: "en-US",
    files: [
      {
        path: "/app/i18n/locales/en.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/